import { useEffect, useState } from 'react';

import PropTypes from 'prop-types';

import { Box } from '@mui/material';

import { useTransl } from 'shared/lib/i18n';

import { formatDateFixedTimezone } from '../../utils';

const ContactPersonDetailsComponent = ({ building }) => {
  const { t } = useTransl();
  const {
    contactPersonName,
    contactPersonPhoneNumber,
    contactPersonPhoneNumberExtension,
  } = building;
  if (contactPersonName) {
    return (
      <Box display="flex" flexWrap="wrap">
        <b>
          {t('callCenter.buildingContact')}: {contactPersonName}
        </b>
        <Box ml="0.5rem" />
        {contactPersonPhoneNumber && <div>{contactPersonPhoneNumber}</div>}
        <Box ml="0.5rem" />
        {contactPersonPhoneNumberExtension && (
          <div>/ {contactPersonPhoneNumberExtension}</div>
        )}
      </Box>
    );
  }
  return null;
};

ContactPersonDetailsComponent.propTypes = {
  building: PropTypes.instanceOf(Object).isRequired,
};

const BuildingLocalTimeComponent = ({ building }) => {
  const { t } = useTransl();
  const buildingTimezone = building?.timezone;
  if (!buildingTimezone) return null;

  const [buildingLocalTime, setBuildingLocalTime] = useState(null);

  const getBuildingLocalTime = () => {
    const buildingLocalTime = formatDateFixedTimezone(
      Date.now(),
      buildingTimezone,
      'MMMM Do, h:mm a',
    );
    setBuildingLocalTime(buildingLocalTime);
  };

  useEffect(() => {
    const clockId = setInterval(getBuildingLocalTime, 1000);
    return () => clockId && clearInterval(clockId);
  }, []);

  return (
    buildingLocalTime && `${t('callCenter.localTime')}: ${buildingLocalTime}`
  );
};

BuildingLocalTimeComponent.propTypes = {
  building: PropTypes.instanceOf(Object).isRequired,
};

const CCBuildingDetailsComponent = ({ building }) => (
  <Box display="flex" justifyContent="space-between" width="100%" pb="0.5rem">
    <ContactPersonDetailsComponent building={building} />
    <BuildingLocalTimeComponent building={building} />
  </Box>
);

CCBuildingDetailsComponent.propTypes = {
  building: PropTypes.instanceOf(Object).isRequired,
};

export default CCBuildingDetailsComponent;
